module.exports = __webpack_public_path__ + "img/logout.aed05065.svg";